import routes from 'src/config/api.routes';
import axiosService from './axiosService';

class FundersService {
  GetAllFunders = async () => axiosService.get(routes.founders);

  CreateFunder = async FunderDTO => axiosService.post(routes.funders, JSON.stringify(FunderDTO));
}
const fundersService = new FundersService();
export default fundersService;
